/**
 * Смена пароля по ссылке из письма (?token=...).
 * Токен сюда приходит из письма, к токену входа отношения не имеет.
 */
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { motion } from 'framer-motion';

import { APIAuthResetPassword } from '../api_auth';
import { passwordError } from '../components/Onboarding/onboardingConfig';
import {
    AuthBackground, Logo, Field, PrimaryButton, TextLink, Notice, StatusScreen,
    PasswordToggle, IconLock,
    IconLinkOff, IconLockCheck,
} from '../components/Auth/ui';

export default function ResetPasswordPage() {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const token = params.get('token') || '';

    const [pw, setPw] = useState('');
    const [pw2, setPw2] = useState('');
    const [showPw, setShowPw] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [done, setDone] = useState(false);

    const submit = async (e) => {
        e?.preventDefault();
        setError(null);
        const pwError = passwordError(pw);
        if (pwError) { setError(pwError); return; }
        if (pw !== pw2) { setError('Пароли не совпадают'); return; }
        setLoading(true);
        try {
            await APIAuthResetPassword({ token, new_password: pw });
            setDone(true);
        } catch (err) {
            setError(err?.response?.data?.error || 'Не удалось сменить пароль. Запросите новую ссылку');
        } finally {
            setLoading(false);
        }
    };

    if (!token) {
        return (
            <StatusScreen icon={<IconLinkOff />} title="Ссылка неполная"
                          text="В ссылке нет кода для смены пароля. Запросите письмо ещё раз.">
                <PrimaryButton onClick={() => navigate('/forgot-password')}>Запросить ссылку</PrimaryButton>
                <TextLink onClick={() => navigate('/login')}>Вернуться ко входу</TextLink>
            </StatusScreen>
        );
    }

    if (done) {
        return (
            <StatusScreen icon={<IconLockCheck />} title="Пароль обновлён" text="Теперь войдите с новым паролем.">
                <PrimaryButton onClick={() => navigate('/login')}>Войти</PrimaryButton>
            </StatusScreen>
        );
    }

    return (
        <AuthBackground>
            <div className="lv-screen lv-login">
                <motion.div className="lv-login__brand"
                            initial={{ opacity: 0, y: -14 }} animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.45 }}>
                    <Logo size="lg" />
                    <div className="lv-login__name">Новый пароль</div>
                    <div className="lv-login__tag">Придумайте пароль, который легко вспомнить</div>
                </motion.div>

                <motion.form className="lv-panel" onSubmit={submit} noValidate
                             initial={{ opacity: 0, y: 26, scale: 0.98 }} animate={{ opacity: 1, y: 0, scale: 1 }}
                             transition={{ delay: 0.12, type: 'spring', stiffness: 260, damping: 26 }}>
                    {error ? <Notice tone="error">{error}</Notice> : null}

                    <Field icon={<IconLock />} type={showPw ? 'text' : 'password'} autoComplete="new-password"
                           placeholder="Минимум 8 символов, буквы и цифры" value={pw} autoFocus
                           onChange={(e) => setPw(e.target.value)}
                           end={<PasswordToggle shown={showPw} onToggle={() => setShowPw((s) => !s)} />} />

                    <Field icon={<IconLock />} type={showPw ? 'text' : 'password'} autoComplete="new-password"
                           placeholder="Ещё раз" value={pw2} enterKeyHint="go"
                           onChange={(e) => setPw2(e.target.value)} />

                    <PrimaryButton type="submit" loading={loading}>
                        {loading ? 'Сохраняем…' : 'Сохранить пароль'}
                    </PrimaryButton>
                </motion.form>
            </div>
        </AuthBackground>
    );
}
